import localStorage from './local-storage'

export const KEY = 'scoir-is-authed'

export const setIsAuthed = () => {
  localStorage.setItem(KEY, 'true')
}

export const getIsAuthed = () => {
  return !!localStorage.getItem(KEY)
}

export const removeIsAuthed = () => {
  localStorage.removeItem(KEY)
}

export const changeIsAuthed = (bool: boolean) => {
  if (bool) {
    removeIsAuthed()
  } else {
    setIsAuthed()
  }
}
